import { Component, Output, OnInit, EventEmitter, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { enumMarineInsuranceStatusType } from '@app/data-layer/enums/marine-insurance/enumInsuranceStatusType.enum';

interface IMarineInsuranceReminderFeature {
  TITLE: string;
  TEXT: string;
}

@Component({
  selector: 'app-marine-insurance-reminder-modal',
  templateUrl: './marine-insurance-reminder-modal.component.html',
  styleUrls: ['./marine-insurance-reminder-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MarineInsuranceReminderModalComponent implements OnInit {
  @Output() public submit: EventEmitter<enumMarineInsuranceStatusType> = new EventEmitter<enumMarineInsuranceStatusType>();

  public isShowExitModal: boolean;

  public features: IMarineInsuranceReminderFeature[] = [];

  constructor(private translateService: TranslateService) {}

  public ngOnInit(): void {
    const features: IMarineInsuranceReminderFeature[] = this.translateService.instant('MARINE_INSURANCE_REMINDER.FEATURES');

    this.features = Array.isArray(features) ? features : [];
  }

  public openCustomModal(): void {
    this.isShowExitModal = true;
  }

  public closeCustomModal(): void {
    this.isShowExitModal = false;
  }

  public onAccept(): void {
    this.emitAnswer(enumMarineInsuranceStatusType.INSURED);
  }

  public onDecline(): void {
    this.emitAnswer(enumMarineInsuranceStatusType.NOT_INSURED);
  }

  private emitAnswer(status: enumMarineInsuranceStatusType): void {
    this.submit.emit(status);
    this.closeCustomModal();
  }
}
